module.exports = __webpack_public_path__ + "static/media/cldc2011_program.19454657.pdf";